/**
 * Designer start-up timeline on top of the User Timing API, so it also shows up in the
 * browser's Performance panel. Times are ms since navigation start.
 *
 *   Veyop.perf.report()  →  [{ step: 'ready', ms: 812 }, …]
 */
const PREFIX = 'veyop:boot:';

export type BootStep = 'start' | 'config' | 'mounted' | 'bootstrap' | 'hydrated' | 'canvas' | 'ready';

export function markBoot(step: BootStep): void {
  try {
    performance.mark(`${PREFIX}${step}`);
    if (step === 'ready') performance.measure('veyop:boot', `${PREFIX}start`, `${PREFIX}ready`);
  } catch {
    // User Timing unavailable (old browser) or a mark is missing: timing is best-effort.
  }
}

export function bootReport(): Array<{ step: string; ms: number }> {
  if (typeof performance === 'undefined' || !performance.getEntriesByType) return [];
  return performance.getEntriesByType('mark')
    .filter((entry) => entry.name.startsWith(PREFIX))
    .map((entry) => ({ step: entry.name.slice(PREFIX.length), ms: Math.round(entry.startTime) }));
}

/** One line for the console, e.g. "start 120 · config 121 · … · ready 812 ms". */
export function bootSummary(): string {
  return bootReport().map(({ step, ms }) => `${step} ${ms}`).join(' · ') + ' ms';
}
